<template>
    <div>
        <div
            class="align-items-center pb-1"
            :class="[
                module !== 'patient' &&
                    Object.values(node.components).length <= 1 &&
                    'padding-child',
                module === 'patient' &&
                    Object.values(node.components).length === 0 &&
                    'padding-child'
            ]"
        >
            <i
                v-if="
                    (module === 'patient' &&
                        Object.values(node.components).length > 0) ||
                    (module !== 'patient' &&
                        Object.values(node.components).length > 1)
                "
                ref="iconAccordion"
                :class="
                    isCollapsed
                        ? 'cus-control-play-blue-down'
                        : 'cus-control-play-blue'
                "
                style="vertical-align: inherit;"
                @click="isCollapsed = !isCollapsed"
            ></i>
            <input
                :id="node.id"
                type="checkbox"
                class="mr-2 cursor-pointer"
                :key="inputKey"
                :disabled="isMedicalNotePatient && node.isactive == 1"
                :checked="isChecked"
                @change="selectedNodes(node, $event)"
            />
            <label
                class="d-inline mb-0"
                :class="{
                    'font-weight-bold': isMakeParentBold
                }"
                :for="node.id"
                >{{ node.name }}</label
            >
        </div>

        <b-collapse v-model="isCollapsed">
            <!-- loop back to current components -->
            <div
                v-for="nodeComponent in node.components"
                :key="nodeComponent.id"
            >
                <recursive-section
                    class="pl-4"
                    :ref="`recursive-section-${nodeComponent.id}`"
                    :node="nodeComponent"
                    :selectedSection="selectedSection"
                    :module="module"
                    :isMakeParentBold="false"
                    @update-checkbox="selectedNodes"
                />
            </div>
        </b-collapse>
    </div>
</template>

<script>
import RecursiveSection from "@/components/soap/new-section-recursive.vue";
import { find, isEmpty, map, remove } from "lodash";
export default {
    name: "RecursiveSection",
    components: {
        RecursiveSection
    },
    props: {
        selectedSection: { type: Array, default: () => [] },
        node: { type: Object, required: true },
        module: { type: String, default: "patient" },
        isMakeParentBold: { type: Boolean, default: false }
    },
    data() {
        return {
            inputKey: 0,
            inputChecked: false,
            isCollapsed: false
        };
    },
    mounted() {
        this.inputChecked = this.node.isactive == 1;
    },
    computed: {
        isMedicalNotePatient() {
            // coming from SOAP Add Section
            return this.module === "patient";
        },
        isChecked() {
            // isactive is from the API which indicate it already checked and saved
            // inputChecked is when input checkbox been checked

            if (this.isMedicalNotePatient) {
                return this.node.isactive == 1 || this.inputChecked;
            } else {
                return this.inputChecked;
            }
        }
    },
    watch: {},
    methods: {
        updateInputKey(selectedSections) {
            // To update the checked input element component
            const node = find(selectedSections, { id: this.node.id });

            this.inputChecked = node ? true : false;
            if (!isEmpty(this.$refs)) {
                // To reduce the array for the child component to check
                remove(selectedSections, { id: this.node.id });

                map(this.$refs, (ref, key) => {
                    if (key.includes("recursive-section")) {
                        ref[0].updateInputKey(selectedSections);
                    }
                });
            }
        },
        selectedNodes(params, event = null) {
            if (event) {
                // When checkbox been checked, the function trigger here
                let node = {
                    isChecked: event.target.checked,
                    parentId: this.node.id,
                    elements: this.addChildNodesToSelection(
                        [],
                        params,
                        event.target.checked
                    )
                };
                params = node;
            } else {
                // trigger parents selectedNodes function from child components this.$emit("update-checkbox", params);
                params.parentId = this.node.id;
                if (params.isChecked) {
                    // The parent will include in the params when isactive is not 0, if 1 means already checked
                    params.elements.push({
                        id: this.node.id,
                        isactive: this.node.isactive,
                        parentIndex: this.node.parentIndex
                    });
                } else if (!params.isChecked) {
                    // remove parents if there is no child
                    let isParentUnchecked = true;

                    if (
                        this.node.isactive == "1" &&
                        this.isMedicalNotePatient
                    ) {
                        isParentUnchecked = false;
                    } else {
                        // Use Object.values to get an array of values from this.node.components
                        const componentsArray = Object.values(
                            this.node.components
                        );

                        isParentUnchecked = componentsArray.every(childNode => {
                            if (
                                !find(params.elements, { id: childNode.id }) &&
                                find(this.selectedSection, {
                                    id: childNode.id
                                })
                            ) {
                                // The child node id is not in params (means the child not the one that triggered checked)
                                // The child node id is in the selectedSection (which one of the child that not triggered the checked is checked)
                                // so parent should not be unchecked and exit the loop
                                return false;
                            }
                            return true;
                        });
                    }

                    if (isParentUnchecked) {
                        params.elements.push({
                            id: this.node.id,
                            isactive: this.node.isactive,
                            parentIndex: this.node.parentIndex
                        });
                    }
                }
            }

            this.$emit("update-checkbox", params);
        },
        addChildNodesToSelection(params, node, isChecked) {
            params.push({
                id: node.id,
                isactive: node.isactive,
                parentIndex: node.parentIndex
            });

            if (!isEmpty(node.components)) {
                map(node.components, childNote => {
                    params = this.addChildNodesToSelection(
                        params,
                        childNote,
                        isChecked
                    );
                });
            }

            return params;
        }
    }
};
</script>
<style scoped>
.padding-child {
    padding-left: 23px;
}
</style>
